var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentCardError = function SvgPaymentCardError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 156
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-15 156.363 -29.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 96.9,
    fill: "#F4F4F4",
    stroke: "#444",
    strokeWidth: 1.7,
    rx: 5.95
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#541CC4",
    d: "M3 13h147v18H3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43 35)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 96.9,
    fill: "#FFF",
    stroke: "#444",
    strokeWidth: 1.7,
    rx: 5.95
  }), /*#__PURE__*/React.createElement("rect", {
    width: 146.9,
    height: 90.8,
    x: 3.05,
    y: 3.05,
    stroke: "#E1D8B7",
    strokeWidth: 2.7,
    rx: 4.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.3 26.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.45,
    height: 19.55,
    fill: "#E1D8B7",
    stroke: "#988642",
    strokeWidth: 2.21,
    rx: 5.525
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#988642",
    strokeLinecap: "square",
    strokeWidth: 0.552,
    d: "M16.15.16v19.23m15.3-9.19H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#541CC4",
    d: "M10.2 6.8h11.9v5.95H10.2z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeWidth: 1.7,
    d: "M15.459 65.45h26.032M15.458 78.2h88.084M46.059 65.45h26.032m4.568 0h26.032m5.418 0h26.032"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(0 1.819)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 42,
    y: 146.181,
    fill: "#988642",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#988642",
    strokeWidth: 1.6,
    d: "m15 146.581 8-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "m19.176 114.181-2.397.12.08 1.598 2.397-.12zm-5.593.28-2.397.119.08 1.598 2.397-.12-.08-1.598zm-5.593.278-2.397.12.08 1.598 2.397-.12zm-5.593.28-2.397.12.08 1.597 2.397-.12-.08-1.598z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 205,
    y: 0.181,
    fill: "#541CC4",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M226.745 42.45h3v-2h-3zm7 0h3v-2h-3zM214 74.676l2.243 1.993 1.328-1.495-2.243-1.993zm5.233 4.65 2.242 1.992 1.329-1.495-2.243-1.992zm5.233 4.65 2.242 1.992 1.329-1.495-2.243-1.993zm5.232 4.649 2.243 1.992 1.329-1.495-2.243-1.992zm5.233 4.65 2.243 1.992 1.328-1.495-2.242-1.993z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149 14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9021C",
    d: "M62.508 32.472c0 17.808-13.993 32.245-31.254 32.245S0 50.28 0 32.472C0 14.662 13.993.226 31.254.226c17.26 0 31.254 14.437 31.254 32.246"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M31.5 13.5v28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 50.5,
    r: 3.5,
    fill: "#FFF"
  })))));
};
export default SvgPaymentCardError;